import React, { ReactElement, useContext, useEffect } from 'react';

import Modal from '../../../../../shared/components/modal/Modal';
import { ModalContext } from '../../../../../shared/components/modal/ModalContext';
import { ModalContextModel } from '../../../../../shared/components/modal/models/modal-context.model';
import useDeleteModal from '../../../../../shared/hooks/use-delete-modal/use-delete-modal';
import { AppTableModel } from '../../../../models/app-table.model';
import { AppsFilters } from '../../../../models/apps-filters.model';
import { AppsHeaderAndPaginationFilters } from '../../../../models/apps-header-and-pagination-filters.model';
import { deleteApp } from '../../../../thunks/delete-app.thunk';
import { getAppsTotalCount } from '../../../../thunks/get-apps-total-count.thunk';
import { getApps } from '../../../../thunks/get-apps.thunk';

export const useShowDeleteModalAppsTable = (
  ids: number[],
  filters?: AppsHeaderAndPaginationFilters
): ReactElement => {
  const ctx = useContext(ModalContext) as ModalContextModel;

  const deleteModal = useDeleteModal<
    AppTableModel,
    number,
    AppTableModel[],
    Partial<AppsHeaderAndPaginationFilters> | undefined,
    number,
    Partial<AppsFilters> | undefined
  >({
    ids: ids,
    deleteAction: deleteApp,
    param: filters,
    afterDeleteAction: getApps,
    resetTotalCount: getAppsTotalCount,
    resetTotalCountParams: filters?.header,
  });

  useEffect(() => {
    if (ids.length && !ctx.isOpen) {
      ctx.componentHandler(deleteModal);
      ctx.modalStateHandler();
    }
  }, [ids]);

  return <Modal>{ctx.component}</Modal>;
};
